'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export function PinterestPixel() {
const pathname = usePathname();

useEffect(() => {
    if (window.pintrk) {
      window.pintrk('page');
    }
  }, [pathname]); // ← Add pathname to the dependency array

if (!process.env.NEXT_PUBLIC_PINTEREST_TAG_ID) {
    return null;
}

return (
    <Script
    id="pinterest-tag"
    strategy="afterInteractive"
    dangerouslySetInnerHTML={{
        __html: `
        !function(e){if(!window.pintrk){window.pintrk = function () {
        window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
        n=window.pintrk;n.queue=[],n.version="3.0";var
        t=document.createElement("script");t.async=!0,t.src=e;var
        r=document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
        pintrk('load', '${process.env.NEXT_PUBLIC_PINTEREST_TAG_ID}');
        pintrk('page');
        `,
    }}
    />
);
}
  